export default (() => ({
  commons: require('./commonApis').default,
  users: require('./authApis').default,
  diagnosis: require('./diagnosisApis').default
}))()
